module.exports = __webpack_public_path__ + "img/logo.7b893e3f.png";